import api from "../config/apiConfig";
import { getSelectedCompany } from "../utils/auth";
import { getAdminId } from "../utils/authId";

export const FetchUserApi = async (data) => {
  const adminId = getAdminId();
  const companyId = getSelectedCompany();
  try {
    const response = await api.get(
      `api/get_mention_staff/?admin=${adminId}&company_id=${companyId.id}${data}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
